module.exports = __webpack_public_path__ + "img/water-management.7d5c394c.jpg";